import { Component, Input, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../../../app.service';
import { LayoutService } from '../../layout/layout.service'; 
import { ApiService } from '../../../share/services/api.service';
import { AzureADUser } from '../../../share/models/azureaduser.model';
import { NotificationService } from '../../../share/services/notification.service';
import { Notification } from '../../../share/models/notification.model';
import { EventService } from '../../../share/services/event.service'; 
import { SharedModule } from '../../../share/shared.module';
import { AuthService } from '../../../share/services/auth.service';
import { AppStateService } from '../../../share/services/appstate.service';
import { ConfigService } from '../../../share/services/config.service';
import { SessionService } from '../../../share/services/session.service';
// declare function updateNotificationsCounter(notifications: any, all: any): any;

@Component({
  selector: 'app-layout-navbar',
  templateUrl: './layout-navbar.component.html',
  styleUrls: ['./layout-navbar.component.scss'],
  imports: [SharedModule]
})
export class LayoutNavbarComponent implements OnInit, OnDestroy {
  isExpanded = false;
  isRTL: boolean;
  // loggedUser: AzureADUser = new AzureADUser();  
  userNotifications: Notification[] = []; 
  timelop: any;
  public loggedUser: {
    displayName: string,
    preferredLanguage: string,
    mail: string,
    groupName: string,
    groupGId: string
  } = {
    displayName: '',
    preferredLanguage: '',
    mail: '',
    groupName: '',
    groupGId: ''
  }

  @Input() sidenavToggle = true;

  @HostBinding('class.layout-navbar') hostClassMain = true;

  constructor(
    private eventService: EventService,
    private appService: AppService,
    private layoutService: LayoutService,
    private api: ApiService,
    private auth: AuthService,
    private appState: AppStateService,
    private notificationService: NotificationService,
    private configService: ConfigService,
    private sessionService: SessionService
  ) {
    this.isRTL = appService.isRTL; 

    //If site is deactivate we don't show any notification
    if (this.configService.isActiveEnvironment()) {
      this.loadLoggedUserNotifications(!this.appState.loadedNotifications, (s: any) => this.loadLoggedUserNotificationsCallback(s));

      if (!this.appState.loadedNotifications) {
        this.appState.loadedNotifications = true;
      }
    }
  }

  // ngOnInit() { 
  //   const session = this.sessionService.getFetrapiSession();
  //   const loggedUser = session ? session : null;
  //   if (this.loggedUser.mail == null) { 
  //     if (this.loggedUser.otherMails.length > 0) { 
  //       this.loggedUser.mail = this.loggedUser.otherMails[0];
  //     }
  //   }
  // }

  ngOnInit() { 
    this.loggedUser = {
      displayName: this.sessionService.getDisplayname(),
      preferredLanguage: this.sessionService.getPreferredLanguage(),
      mail: this.sessionService.getMail(),
      groupName: this.sessionService.getMaingroupName(),
      groupGId: this.sessionService.getMaingroupGId()
    }
    // const session = this.sessionService.getFetrapiSession();
    // this.loggedUser = session ? session : null;
    // if (this.loggedUser.mail == null) { 
    //   if (this.loggedUser.otherMails.length > 0) { 
    //     this.loggedUser.mail = this.loggedUser.otherMails[0];
    //   }
    // }
  }

  ngOnDestroy() {
    clearTimeout(this.timelop); 
  }

  public hasNotifications(): boolean {
    return this.notificationService.getNotificationsCounter() > 0;
  }

  //Retrieves all user's notifications
  //showNotifications: true shows the notifications to the user
  loadLoggedUserNotifications(showNotifications: any, callback: any) { 
    this.notificationService.clearAllNotifications();
    this.api.getNotifications().subscribe((data: any) => { 
      if (showNotifications) {
        let delay = 250;
        for (let i = 0; i < data.length; i++) {
          setTimeout(() => {
           //console.log(data[i].dateTimeCreated + '->' + moment.utc(data[i].dateTimeCreated).toDate() + '->' + moment(data[i].dateTimeCreated).format('YYYY-MM-DD HH:mm:ss'));
           this.notificationService.showFetrapiNotification(data[i].message, data[i].notificationId) 
          }, delay);
          delay += 250;
        }
      }
       
      callback(data, null);

    })
  } 

  //Retrieves notifications created 5 seconds before
  showLatestNotifications(callback: any) {
    clearTimeout(this.timelop);
    this.api.getNotifications().subscribe({
      next: (data: any) => {  
        callback(data, null);
      },
      error: (error: any) => {
        this.api.errorhandler(error);
      }
    })

    this.timelop = setTimeout(() => {
      this.showLatestNotifications(callback);
    }, 5000);
  }

  showNotifications() {
    this.loadLoggedUserNotifications(true, (s: any) => this.loadLoggedUserNotificationsCallback(s));
  }

  // private updateNotificationsCounter(notifications: number, all: boolean): void {
  //   this.notificationsCounter = all ? notifications : this.notificationsCounter + notifications; 
  // }
  getNotificationsCounter(): number {
    return this.notificationService.getNotificationsCounter();
  }


  loadLoggedUserNotificationsCallback(notifications: any) {
    this.userNotifications = notifications;
    this.notificationService.updateNotificationsCounter(notifications.length, true);

    this.showLatestNotifications((s: any) => this.showLatestNotificationsCallback(s)); 
  }

  showLatestNotificationsCallback(notifications: any) {
    
    var newNot = 0; let delay = 250;
    for (var i = 0; i < notifications.length; i++) { 
      //Show only notifications not added yet to the notifications list
      if (this.userNotifications && !this.userNotifications.find(s => s.notificationId == notifications[i].notificationId)) {
        this.userNotifications.push(notifications[i]);
        //Publish the notification
        this.eventService.sendNotificationEvent(notifications[i]);
        newNot++;
        var message = notifications[i].message;
        var id = notifications[i].notificationId;
        setTimeout(() => {
          this.notificationService.showFetrapiNotification(message, id)
        }, delay);
        delay += 250;
      }
    }

    this.notificationService.updateNotificationsCounter(newNot, false); 
  }

  currentBg() {
    return `bg-${this.appService.layoutNavbarBg}`;
  }

  toggleSidenav() {
    this.layoutService.toggleCollapsed();
  }

  onLogout() {
    this.auth.logOut();
  } 
}

